<div class="content">
  @if (isVerified) {
  <h1>🎉 Email Verification Success 🚀</h1>
  <p>
    Welcome to <b>{{appname}}</b>! 🌸 Your email has been successfully verified,
    and you're now part of our fabulous community! 💖
  </p>
  <p>
    Get ready to explore the latest in women's activewear, curated just for you.
    Shop supportive styles, move with confidence, and keep your routine feeling
    fresh with {{appname}}.
  </p>
  <app-button type="filled" routerLink="/"
    >Shop Now | Explore Your Style</app-button
  >
  <p>Thank you for joining us! 😊</p>
  } @if (notFound) {
  <h1>🚫 Email Verification Failed</h1>
  <p>
    Oops! 😅 It looks like the page you're trying to reach has gone on a little
    detour.
  </p>
  <p>
    No worries, <b>{{appname}}</b> has plenty of fabulous finds waiting for you.
    Head back to our homepage to explore the latest styles! 🌸
  </p>
  <app-button type="text" routerLink="/"
    >Return to {{appname}} Homepage 🛍️</app-button
  >
  } @if(isUsed){
  <h1>Verification Link Already Used 😊</h1>
  <p>
    Oh, it seems this verification link has already been used! 🙈 Your
    <b>{{appname}}</b> account is likely already verified and ready to shine. 🌟
  </p>
  <p>
    Try logging in to explore our collection of women's activewear.
  </p>
  <p>If you run into any issues, our team is here to help. 💖</p>
  <div class="actions">
    <app-button routerLink="/login">Log In to {{appname}} ✨</app-button>
    <app-button routerLink="/">Explore {{appname}} 🌸</app-button>
  </div>
  } @if (isExpired) {
  <h1>Verification Link Expired 😔</h1>
  <p>
    Oops! This verification link has expired. No worries, though—you can still
    join the {{appname}} community.
  </p>
  <p>
    Request a new verification link below to get back on track and start
    exploring our women's activewear collection.
  </p>
  <app-button routerLink="/signup">Request New Link ✨</app-button>
  }
</div>
